import { LegendsLayout } from '@modules/charts/types';
import { Box, Stack } from '@mui/material';
import { useMemo } from 'react';
import { FieldNames } from 'v2/core/entities/fields';
import { HorizontalLegend } from '../HorizontalLegend';
import { VerticalLegend } from '../VerticalLegend';

export interface PieChartLegendProps {
  labelKey: string;
  data: any[];
  fieldName?: FieldNames;
  layout: LegendsLayout;
  shouldShowLegendsInNewRow?: boolean;
  onMouseEnter?: (event: React.MouseEvent, index: number) => void;
  onMouseLeave?: (event: React.MouseEvent) => void;
}

export function PieChartLegend(props: PieChartLegendProps) {
  const {
    data,
    layout,
    labelKey,
    fieldName,
    shouldShowLegendsInNewRow = false,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const totalRecords = useMemo(() => {
    return data.reduce((acc, item) => acc + item.value, 0);
  }, [data]);

  const labels = useMemo(() => {
    return data.map((item) => ({
      name: item[labelKey],
      value: item.value,
      id: item.id,
    }));
  }, [data, labelKey]);

  return (
    <Box width="100%">
      <Stack justifyContent="center" alignItems="center">
        {layout === 'horizontal' || shouldShowLegendsInNewRow ? (
          <HorizontalLegend
            labels={labels}
            totalRecords={totalRecords}
            fieldName={fieldName}
            shouldShowLegendsInNewRow={shouldShowLegendsInNewRow}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        ) : (
          <VerticalLegend
            labels={labels}
            totalRecords={totalRecords}
            fieldName={fieldName}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        )}
      </Stack>
    </Box>
  );
}
